import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class MortgageSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="illustration_mortgage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon fill="#FFFFFF" points="48 43 48 69 80 69 80 43 64 26" />
          <path
            d="M32,26.0006 L64,26.0006 L48,43 L16,43 L32,26.0006 Z M84.456839,26 C84.4577361,26 84.4586333,26 84.4595304,26 C86.9948751,26 89.488951,27.2676182 90.1151614,29.0061173 C91.0347397,31.5547819 88.2185872,34.1911772 88.9695014,36.7666982 C89.4279448,38.3360024 91.1235575,39.5660218 92.0942734,41.0144726 C93.5709816,43.2184811 93.2184018,45.9739394 91.2087868,47.9559357 C90.3008714,48.8520416 89.0744679,49.6120754 88.4949092,50.6335107 C87.2433856,52.8473666 89.4387106,55.2348933 89.7733474,57.6072015 C90.1438702,60.2373303 87.3842381,61.9122694 83.6305642,61.9973144 L81.800379,62 C79.4507442,61.8388621 77.2536249,60.8263789 76.1016848,59.3761377 C74.9506419,57.9267917 74.8779728,56.0781817 75.9132834,54.5867608 C76.7889014,53.3227234 78.4109479,52.2717462 78.6495897,50.877008 C78.9169402,49.3103894 77.6277363,49.0087034 76.3277665,47.723181 C75.0286939,46.4394489 72.8961694,45.1655642 74.6850856,42.2650818 C75.5104633,40.9258467 77.4806038,40.1855075 78.8155623,39.0691799 C80.3389223,37.7944 80.060806,35.8893918 79.3610293,34.2994977 C78.6603555,32.706918 78.2351066,31.5503059 78.489897,29.893271 C78.7859564,27.9640921 81.0943223,26.255135 83.8324228,26.0250659 C84.0396644,26.0080569 84.2487002,26 84.456839,26 Z"
            className={css(styles.action)}
            fill="#0098DA"
          />
          <path
            d="M66.9723343,56.9987004 L67,56.9987004 L67,69 L59,69 L59,56.9987004 L59.0276657,56.9987004 C59.2609798,54.7470743 60.9504323,53 63.0004611,53 C65.0504899,53 66.7399424,54.7470743 66.9723343,56.9987004 Z M16,69 L16,43 L48,43 L48,69 L16,69 Z M83,49 C83.5522847,49 84,49.4477153 84,50 L84,70 C84,70.5522847 83.5522847,71 83,71 C82.4477153,71 82,70.5522847 82,70 L82,50 C82,49.4477153 82.4477153,49 83,49 Z"
            className={css(styles.actionAccent)}
            fill="#005072"
          />
          <polygon fill="#FFFFFF" points="23.005 59 28.005 59 28.005 51 23.005 51" />
          <polygon fill="#FFFFFF" points="36 59 41 59 41 51 36 51" />
          <path
            d="M5.7339,65.7269 C7.0169,65.7269 7.7379,67.5719 8.3089,67.2549 C9.2849,66.7129 8.4229,62.9829 11.6849,62.9589 C13.8519,62.9449 13.1679,65.7099 14.1969,65.7769 C15.0649,65.8319 14.8379,62.6939 17.5419,62.9589 C20.0509,63.2059 19.0999,66.1939 20.0509,66.4559 C21.8079,66.9429 21.5229,65.3199 23.6139,65.8199 C25.5169,66.2759 24.909,69.44 24,73 C18.313,73.047 11.639,73.035 4,73 C3.66491699,71.9310303 3.45422363,71.4598999 3.0449,68.8079 C2.82922363,67.2549 3.9159,65.7269 5.7339,65.7269 Z"
            className={css(styles.grey)}
            fill="#CBD6DB"
          />
          <g id="Group" transform="translate(82.000000, 49.000000)" />
        </g>
      </svg>
    );
  }
}
